<template>
  <div class="login">
    <div class="container">
      <div class="form">
        <div class="title">
          Let's Get Started
        </div>
        <div class="input-wrap centered">
					<label class="muted-text">Is this your first time activating one of our kits?</label>
          <router-link to="/activate" tag="a">
						<button
							class="btn"
						>Create Account
						</button>
					</router-link>
        </div>
				<div class="or-wrap centered">
					<span class="or-text">OR</span>
				</div>
        <div class="input-wrap centered">
					<label class="muted-text">Have you activated one of our kits before?</label>
					<router-link to="/login" tag="a">
						<button
							class="btn"
						>Sign In
						</button>
					</router-link>
        </div>
			</div>
		  <img src="../images/bg/spinner.png" alt="Spinner" class="spiner" />
		</div>
	</div>
</template>

<script>
export default {
  name: "SplashScreen"
};
</script>

<style scoped lang="scss">
@import "../styles/colors";
.login {
  max-width: 100%;
  width: 100vw;
  height: auto;
  min-height: calc(100vh - 60px);
  display: flex;
  background-color: transparent;
  padding: 100px 0 0 0;
}
.form {
  padding: 36px 80px 40px 80px;
  box-shadow: 0 3px 15px -9px $boxShadow;
  background-color: $white;
  max-width: 550px;
  width: 50%;
  margin: 40px 0 0 auto;
  position: relative;
  border-radius: 15px;
  font-family: TTNormsMedium, sans-serif;
}
.title {
  color: $blue;
  font-family: TTNormsBold, sans-serif;
  font-size: 27px;
  text-align: center;
  margin: 0 0 36px 0;
}
.input-wrap.input {
  border: 1px solid $red;
}
.or-wrap {
  margin: 35px 0px;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 20px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsBold, sans-serif;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.spiner {
  display: none;
}
@media screen and (max-width: 1000px) {
  .form {
    padding: 30px;
    max-width: 450px;
  }
}
@media screen and (max-width: 768px) {
  .login {
    background: url("../images/bg/sky-mobile.jpg");
    padding: 90px 0 0 0;
  }
  .form {
    width: 100%;
    margin: 0 auto;
  }
  .spiner {
    display: flex;
    width: 68px;
    height: 68px;
    margin: 26px auto;
  }
}
@media (max-width: 568px) {
  .form {
    padding: 36px 20px 40px 20px;
  }
  .login {
    padding: 90px 0 0 0;
  }
}
.centered {
	text-align: center;
}
.muted-text {
	color: #6b6b6b;
}
.or-text {
	color: #43B02A;
	font-weight: bold;
  position: relative;
}
.or-text::before {
  content: "";
  display: block;
  width: 60px;
  height: 1px;
  background: #b4b3b3;
  right: 38px;
  top: 50%;
  position: absolute;
}
.or-text::after {
  content: "";
  display: block;
  width: 60px;
  height: 1px;
  background: #b4b3b3;
  left: 37px;
  top: 50%;
  position: absolute;
}
@media screen and (max-width: 415px) {
  .btn {
    width: 100%;
  }
}
</style>
